import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Collapse, Icon } from 'antd';
import { CognitoUser, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import SuperSettings from '../superUser/SuperSettings';
import EmailSettings from './EmailSettings';
import PasswordSettings from './PasswordSettings';
import NotificationSettings from './NotificationSettings';
import store from '../../reducers/store';
import getCurrentUser from '../../authentication/getCurrentUser';
import getUserAttributes from '../../authentication/getUserAttributes';
import logoutUser from '../../authentication/logout';

import '../../combinedStyles';

const Panel = Collapse.Panel;

class Settings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cognitoUser: null,
      email: '',
    };
  }

  logout() {
    logoutUser().then(() => {
      store.dispatch({ type: 'UPDATE_LOGGEDIN', loggedIn: false });
      this.props.history.push('/login');
    });
  }

  render() {
    if (this.props.activeUser.super_user) {
      return <SuperSettings logout={this.logout.bind(this)} />;
    } else {
      return (
        <Collapse bordered={false}>
          <Panel header={'Change Password'} key='2'>
            <PasswordSettings
              cognitoUser={this.state.cognitoUser}
              logout={this.logout.bind(this)}
            />
          </Panel>
        </Collapse>
      );
    }
  }
}

function mapStoreToProps(storeState) {
  return {
    loggedIn: storeState.main.loggedIn,
    redirected: storeState.main.redirected,
    organization: storeState.main.organization,
    displayedUser: storeState.main.displayedUser,
    activeUser: storeState.main.activeUser,
  };
}

export default connect(mapStoreToProps)(Settings);



// WEBPACK FOOTER //
// ./src/components/userSettings/Settings.js